module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/babel-runtime/core-js/promise.js
 ** module id = 4
 ** module chunks = 2
 **/